import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import { getInsuranceOfferRequests } from "./modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    offerRequests: state.insuranceOfferRequestReducer.insuranceOfferRequests,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getInsuranceOfferRequests,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
